import {Components} from '@mui/material';

import {Colors} from '@constants/colors.constants';

const dialog: Components = {
  MuiDialog: {
    styleOverrides: {
      root: (props) => ({
        backdropFilter: 'blur(4px)',
        backgroundColor: Colors.blur,
        ...(props.ownerState['aria-label'] === 'small-padding' ? {
          '& .MuiDialogContent-root': {
            padding: '0 20px',
          },
          '& .MuiDialogActions-root': {
            margin: '20px 0',
          },
        } : {}),
        ...(props.ownerState['aria-label'] === 'over-drawer' ? {
          backgroundColor: 'transparent',
          zIndex: 1301,
        } : {}),
      }),
      paper: {
        backgroundColor: Colors.background,
        borderRadius: 4,
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        alignItems: 'center',
        backgroundColor: Colors.white,
        display: 'flex',
        fontSize: 18,
        fontWeight: 700,
        height: 55,
        justifyContent: 'center',
        position: 'relative',
        textAlign: 'center',
        '& .MuiIconButton-root[aria-label=close]': {
          bottom: 0,
          margin: 'auto 0',
          padding: 4,
          position: 'absolute',
          right: 15,
          top: 0,
        },
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0 40px',
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        justifyContent: 'center',
        margin: '40px 0',
        padding: 0,
        '& > .MuiButton-root:nth-of-type(n)': {
          '&:not(:first-of-type)': {
            margin: '0 0 0 20px',
          },
        },
      },
      spacing: {
        padding: 0,
      },
    },
  },
};

export default dialog;
